import { useQueryClient } from "@tanstack/react-query";
import useUnpostedSessionsMatchPath from "./use_unposted_sessions_match_path";
import { QUERY_KEYS } from "../../../api/constants/query_keys";
import { useCallback, useContext } from "react";
import { UnpostedSessionsContext } from "../context/unposted_sessions_provider";

const useRefetchUnpostedSessionsRequests = () => {
  const queryClient = useQueryClient();
  const unpostedSessionsViewMatch = useUnpostedSessionsMatchPath();
  const context = useContext(UnpostedSessionsContext);

  const refetchUnpostedSessionsCount = useCallback(() => {
    queryClient.refetchQueries({
      queryKey: QUERY_KEYS.v1SessionsUnpostedCountGet,
    });
  }, [queryClient]);

  const refetchSlimCards = useCallback(() => {
    // Use the mutation-based refetch functions from context
    if (context?.refetchMyUnpostedSessions) {
      context.refetchMyUnpostedSessions();
    }
    if (context?.refetchDecUnpostedSessions) {
      context.refetchDecUnpostedSessions();
    }
    if (context?.refetchAssistantsUnpostedSessions) {
      context.refetchAssistantsUnpostedSessions();
    }
  }, [context?.refetchMyUnpostedSessions, context?.refetchDecUnpostedSessions, context?.refetchAssistantsUnpostedSessions]);

  const refetchUser = useCallback(() => {
    queryClient.refetchQueries({
      queryKey: QUERY_KEYS.v1UsersIdGet,
    });
  }, [queryClient]);

  // If we are currently in the notator view, refetch the unposted sessions count, slim cards, and user
  const refetchOnSessionAction = useCallback(() => {
    refetchUnpostedSessionsCount();
    refetchSlimCards();
  }, [refetchUnpostedSessionsCount, refetchSlimCards]);

  const refetchOnCaseloadAction = useCallback(() => {
    refetchUnpostedSessionsCount();
    refetchUser();
    if (unpostedSessionsViewMatch.customId !== "none") {
      refetchSlimCards();
    }
  }, [refetchUnpostedSessionsCount, refetchUser, refetchSlimCards, unpostedSessionsViewMatch.customId]);

  return {
    inUnpostedSessionsView: unpostedSessionsViewMatch.customId !== "none",
    refetchOnSessionAction,
    refetchOnCaseloadAction,
  };
};

export default useRefetchUnpostedSessionsRequests;
